import { Component, input, output, model, OnInit, inject, effect, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SheetSelectComponent } from 'app/core/components/sheet-select/sheet-select.component';
import { FormMode } from 'app/core/constants/form-mode';
import { CatalogService } from '@services/data/catalog.service';
import { AuthService } from '@services/core/auth.service';
import { AppSettings } from '@services/settings/app-settings.service';
import { registerLocaleData, DatePipe } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import { RutFormatPipe } from 'app/core/pipes/rut-format.pipe';
import { PhoneFormatPipe } from 'app/core/pipes/phone-format.pipe';

registerLocaleData(localeEs);

@Component({
  selector: 'app-party-form',
  templateUrl: './party-form.component.html',
  styleUrl: './party-form.component.css',
  standalone: true,
  imports: [ReactiveFormsModule, SheetSelectComponent, DatePipe, RutFormatPipe, PhoneFormatPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [{ provide: LOCALE_ID, useValue: 'es' }]
})
export class PartyFormComponent implements OnInit {
  partyForm = input.required<FormGroup>();
  formChange = output<FormGroup>();
  mode = model<FormMode>(FormMode.CREATE);
  formMode = FormMode;
  statusData: any;
  partyTypes: any;
  groups: any;
  entities: any;

  private catalogService = inject(CatalogService);
  private authService = inject(AuthService);
  readonly appSettings = inject(AppSettings);

  displayValue(value: any): string {
    const text = value == null ? '' : String(value).trim();
    return text || '—';
  }

  constructor() {
    effect(() => {
      this.statusData = (this.catalogService.statuses() || []).filter(
        (s: any) => s.isActive !== false
      );
      this.partyTypes = this.catalogService.partyTypes() || [];
      const currentGroup = this.partyForm()?.get('groupSlug')?.value;
      this.groups = (this.catalogService.groups() || []).filter(
        (g: any) => g.isActive !== false || g.slug === currentGroup
      );
      const assigned: any[] = this.authService.sharingEntities() || [];
      const currentCode = this.partyForm()?.get('entityCode')?.value;
      this.entities = assigned.filter((e: any) =>
        e.isActive !== false || Number(e.code) === Number(currentCode)
      );

      // Lógica de selección de entidad por defecto
      const currentControl = this.partyForm().get('entityCode');
      if (this.mode() === this.formMode.CREATE && currentControl && !currentControl.value) {
        if (this.entities?.length === 1) {
          currentControl.setValue(this.entities[0].code);
        } else {
          // Sugerir la entidad que el usuario tiene seleccionada actualmente en el header
          const activeEntity: any = this.authService.sharingEntity();
          if (activeEntity && activeEntity.code && activeEntity.isActive !== false) {
            currentControl.setValue(activeEntity.code);
          }
        }
      }
    });
  }

  submit() {
    if (this.partyForm() && this.partyForm().valid) {
      this.formChange.emit(this.partyForm());
    }
  }

  editMode() {
    this.mode.set(this.formMode.EDIT);
  }

  ngOnInit(): void {
    // Catálogos cargados vía signals
  }

  findStatus(slug: string) {
    let name = this.statusData?.find((item) => item.slug === slug);
    return name ? name.name : '';
  }

  findPartyType(slug: string) {
    const name = this.partyTypes?.find((item) => item.slug === slug);
    if (name) return name.name;
    return this.partyForm().get('partyTypeName')?.value || '';
  }

  findGroup(slug: string) {
    const name = this.groups?.find((item) => item.slug === slug);
    if (name) return name.name;
    return this.partyForm().get('groupName')?.value || '';
  }

  findEntity(code: any): string {
    if (code == null || code === '') return '';
    const fromCatalog = this.catalogService.getEntityName(code);
    if (fromCatalog) return fromCatalog;
    const num = Number(code);
    const fromAuth = (this.entities || []).find((item: any) => Number(item.code) === num);
    return fromAuth?.name || this.partyForm().get('entityName')?.value || '';
  }

}
